import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { getAffiliations } from "../../../store/personal-user";
import AffiliationListItem, {
  affiliationListItemPropType
} from "../affiliation-list-item";
import { FormattedMessage } from "react-intl";
import messages from "./affiliations-list-messages";

import "./affiliations-list.scss";

const AffiliationsList = ({ affiliations = [] }) => {
  return (
    <div className="affiliations-list">
      {affiliations.length === 0 ? (
        <p className="affiliations-list__empty">
          <FormattedMessage {...messages.empty} />
        </p>
      ) : (
        <ul className="affiliations-list__populated">
          {affiliations.map(({ customerId, ...rest }) => (
            <AffiliationListItem key={customerId} {...rest} />
          ))}
        </ul>
      )}
    </div>
  );
};

AffiliationsList.propTypes = {
  affiliations: PropTypes.arrayOf(
    PropTypes.shape({
      customerId: PropTypes.string,
      ...affiliationListItemPropType
    })
  )
};

const mapStateToProps = state => ({
  affiliations: getAffiliations(state)
});

export { AffiliationsList };
export default compose(connect(mapStateToProps))(AffiliationsList);
